import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {
  userIsAuthenticatedRedir,
  userIsNotAuthenticatedRedir,
  userIsLockedRedir
} from './utils/helpers/auth';

import ContainerRoute from './utils/helpers/ContainerRoute';
import Login from './users/loggedUser/Login';
import Register from './users/loggedUser/Register';
import ForgotPassword from './users/loggedUser/ForgotPassword';
import ResetPassword from './users/loggedUser/ResetPassword';
import ConfirmEmail from './users/loggedUser/ConfirmEmail';
import Notification from './containers/MessageWrapper';
import NotFoundComponent from './components/NotFoundComponent';
import Home from './containers/HomeContainer';
import CreateHotel from './hotels/CreateHotel';
import HotelWizard from './hotels/Wizard';
import Synchronization from './synchronization';
import Settings from './components/SettingsComponent';
import CleaningList from './cleaning/CleaningList';
import ScheduleCleaning from './cleaning/schedule/ScheduleCleaningContainer';
import AboutComponent from './components/AboutComponent';
import TabEditComponent from './components/EditUserTabComponent';
import LoginAs from './components/LoginAs';
import Wallet from './wallet';
import Payment from './payment';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route
              exact
              path="/login"
              component={userIsNotAuthenticatedRedir(Login)}
            />
            <Route
              exact
              path="/login-as"
              component={userIsNotAuthenticatedRedir(LoginAs)}
            />
            <Route
              exact
              path="/register"
              component={userIsNotAuthenticatedRedir(Register)}
            />
            <Route
              exact
              path="/forgotpassword"
              component={userIsNotAuthenticatedRedir(ForgotPassword)}
            />
            <Route
              exact
              path="/resetpassword"
              component={userIsNotAuthenticatedRedir(ResetPassword)}
            />
            <Route
              exact
              path="/confirmemail"
              component={userIsNotAuthenticatedRedir(ConfirmEmail)}
            />
            <ContainerRoute
              exact
              path="/"
              component={userIsAuthenticatedRedir(userIsLockedRedir(Home))}
            />
            <ContainerRoute
              exact
              path="/hotel"
              component={userIsAuthenticatedRedir(
                userIsLockedRedir(CreateHotel)
              )}
            />
            <ContainerRoute
              path="/hotel/create"
              component={userIsAuthenticatedRedir(
                userIsLockedRedir(HotelWizard)
              )}
            />
            <ContainerRoute
              path="/hotel/synchronize"
              component={userIsAuthenticatedRedir(
                userIsLockedRedir(Synchronization)
              )}
            />
            <ContainerRoute
              requireHotel
              path="/settings"
              component={userIsAuthenticatedRedir(userIsLockedRedir(Settings))}
            />
            <ContainerRoute
              requireHotel
              exact
              path="/cleaning"
              component={userIsAuthenticatedRedir(
                userIsLockedRedir(CleaningList)
              )}
            />
            <ContainerRoute
              requireHotel
              path="/cleaning/schedule"
              component={userIsAuthenticatedRedir(
                userIsLockedRedir(ScheduleCleaning)
              )}
            />
            <ContainerRoute
              path="/about"
              component={userIsAuthenticatedRedir(
                userIsLockedRedir(AboutComponent)
              )}
            />
            <ContainerRoute
              path="/wallet"
              component={userIsAuthenticatedRedir(Wallet)}
            />
            <ContainerRoute
              path="/payment"
              component={userIsAuthenticatedRedir(Payment)}
            />
            <ContainerRoute
              requireHotel
              path="/users/:id"
              component={userIsAuthenticatedRedir(
                userIsLockedRedir(TabEditComponent)
              )}
            />
            <Route path="*" component={NotFoundComponent} />
          </Switch>
          <Notification />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js